import type { Calls, Chat } from '../types';
import type { IChatRealTimeService } from '../types/chat';
import { CallSignalingModuleIdentifier, CallSignalingType } from '../types/enums';
import Utils from '../Utils';

export default class WebRTCSignalingProvider {
  public chatService: IChatRealTimeService;

  constructor(chatService: IChatRealTimeService) {
    this.chatService = chatService;
  }

  public sendCandidate(
    userID: Chat.UserId,
    iceCandidates: RTCIceCandidateInit[],
    ext: Calls.ExtensionParams = {}
  ): void {
    const extension = Object.assign({}, ext, { iceCandidates });

    this.sendMessage(userID, extension, CallSignalingType.CANDIDATE);
  }

  public sendMessage(userID: Chat.UserId, ext: Calls.ExtensionParams, signalingType: CallSignalingType): void {
    const extension = Object.assign({}, ext);
    /** basic parameters */
    extension.moduleIdentifier = CallSignalingModuleIdentifier;
    extension.signalType = signalingType;
    /** extension.sessionID */
    /** extension.callType */
    extension.platform = Utils.env.isBrowser ? 'web' : Utils.env.isReactNative || Utils.env.isExpo ? 'mobile' : 'node';
    /** extension.callerID */
    /** extension.opponentsIDs */
    /** extension.sdp */

    if (extension.userInfo) {
      if (!Object.keys(extension.userInfo).length) {
        delete extension.userInfo;
      } else if (extension.userInfo.maxBandwidth === 0) {
        delete extension.userInfo.maxBandwidth;
      }
    }

    const systemCallMessage: Chat.SystemMessageParams = {
      id: Utils.getBsonObjectId(),
      extension: extension,
    };

    this.chatService.sendWebRTCSignalingMessage(userID, systemCallMessage);
  }
}
